/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Answer } from './Answer';
export type Question = {
    id?: string;
    question: string;
    type: Question.type;
    answers?: Array<Answer>;
    position?: number;
};
export namespace Question {
    export enum type {
        ONE = 'one',
        MULTIPLY = 'multiply',
        TEXT = 'text',
    }
}

